<template>
  <div class="public-content order">
    <div class="breadcrumb">售后审核</div>
    <div class="right-main">
      <el-form :inline="true" :model="formInline" label-width="100px" class="demo-form-inline">
        <el-row>
          <el-col :span="6">
            <el-form-item label="订单号:">
              <el-input v-model="formInline.orderNo" placeholder="请输入订单号" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="用户名:">
              <el-select clearable v-model="formInline.userId" :filter-method="selectUserList" filterable placeholder="请输入用户名">
                <el-option v-for="item in userList" :key="item.id" :label="item.userName" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="平台号:">
              <el-select clearable v-model="formInline.storeId" :filter-method="filterMethod" filterable placeholder="请输入平台号">
                <el-option v-for="item in storeListByCode" :key="item.id" :label="item.code" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="平台名称:">
              <el-select clearable v-model="formInline.storeId" :filter-method="filterByName" filterable placeholder="请输入平台名称">
                <el-option v-for="item in storeListByCode" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="售后类型:">
              <el-select v-model="formInline.refundType" placeholder="请选择" clearable>
                <el-option label="" value="">全部</el-option>
                <el-option v-for="item in tradeMethods" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="业务:">
              <el-select clearable v-model="formInline.salesmanId" :filter-method="selectSalemanList" filterable placeholder="请输入业务名称">
                <el-option v-for="item in salemanList" :key="item.id" :label="item.fullName" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="审核状态:">
              <el-select v-model="formInline.auditStatus" placeholder="请选择" clearable>
                <el-option label="待审核" value="APPLY"></el-option>
                <el-option label="审核通过" value="AUDITED"></el-option>
                <!-- <el-option label="审核拒绝" value="REJECTED"></el-option> -->
                <!-- <el-option label="已取消" value="CANCELLED"></el-option> -->
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="申请日期:" class="el-date-width">
              <el-date-picker v-model="value2" type="daterange" format="yyyy-MM-dd" value-format="yyyy-MM-dd" :clearable="true" align="left" unlink-panels range-separator="至"
                start-placeholder="请选择开始日期" end-placeholder="请选择结束日期" :picker-options="pickerOptions">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6" class="fn-right form-btn">
            <el-button @click="queryInfo.pageNum = 1, onSubmit()" round>查询</el-button>
            <el-button @click="exportExcel" round v-if="$hasPermission('oms:admin:orderRefund:export')"> 导出Excel </el-button>
          </el-col>
        </el-row>
      </el-form>
      <div class="data-list">
        <el-table :data="tableData" fit border :row-class-name="rowClassName" style="width: 100%">
          <el-table-column label="订单号" fixed="left" min-width="230px">
            <template v-slot="scope">
              <span @click="goInfo(scope.row)" class="color-blue">{{ scope.row.order.orderNo }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="order.userName" label="用户名" min-width="120px"></el-table-column>
          <el-table-column prop="order.storeCode" label="平台号" min-width="100px"></el-table-column>
          <el-table-column prop="order.storeName" label="平台名称" min-width="130px"></el-table-column>
          <el-table-column prop="order.salesman" label="业务" min-width="130px"></el-table-column>
          <el-table-column prop="totalPrice" label="变更金额" min-width="80px"></el-table-column>
          <el-table-column prop="refundType" label="售后类型">
            <template slot-scope="scope">
              <span>{{ scope.row.refundType === 'EXPRESS_FEE' ? '订单扣费' : scope.row.refundType === 'REBATE' ? '订单返款' : '' }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="storeCode" label="申请平台号" min-width="100px"></el-table-column>
          <el-table-column prop="storeName" label="申请平台名称" min-width="150px"></el-table-column>
          <el-table-column prop="salesman" label="申请平台业务" min-width="150px"></el-table-column> -->
          <el-table-column prop="dateCreated" label="申请日期" min-width="170px"></el-table-column>
          <el-table-column prop="order.priceReal" label="实付总价" min-width="80px"></el-table-column>
          <el-table-column label="支付状态" min-width="100px">
            <template slot-scope="scope"> {{ $config.paymentStatus[scope.row.paymentStatus] }} </template>
          </el-table-column>
          <el-table-column prop="auditStatus" label="审核状态" fixed="right">
            <template slot-scope="scope">
              <!--class="color-blue" @click="$router.push({ path: '/refund/express-fee', query: { refundId: scope.row.id, orderNo: scope.row.order.orderNo } })" -->
              <span v-if="scope.row.auditStatus === 'APPLY' && scope.row.refundType === 'EXPRESS_FEE'">待审核</span>
              <!-- class="color-blue"  @click="$router.push({ path: '/refund/rebate', query: { refundId: scope.row.id, orderNo: scope.row.order.orderNo } })"-->
              <span v-else-if="scope.row.auditStatus === 'APPLY' && scope.row.refundType === 'REBATE'">待审核</span>
              <span v-else>{{ $config.auditStatus[scope.row.auditStatus] }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--    分页-->
      <v-pagination class="v-pagination" @changePage="changePage" :queryInfo='queryInfo'></v-pagination>
    </div>
  </div>
</template>
<script>
import VPagination from '@/components/Pagination/index.vue'
import { getOrderRefunds, refundExport } from '@/api/refund'
import {
  storeTypeGetStoreTypeList,
  storeQueryListByCode,
  getSalesmanByFullName,
  storeQueryListByName,
  getAllUsersByUserName
} from '@/api/crm'
export default {
  name: 'refund',
  components: {
    VPagination
  },
  watch: {
    value2: {
      handler (val, oldVal) {
        console.log(val)
        if (val) {
          this.formInline.dateStart = val[0] + ' 00:00:00'
          this.formInline.dateEnd = val[1] + ' 23:59:59'
        } else {
          this.formInline.dateStart = ''
          this.formInline.dateEnd = ''
        }
      },
      deep: true,
      immediate: true
    }

  },
  data () {
    return {
      userList: [],
      salemanList: [],
      storeListByCode: [],
      queryInfo: {
        total: 0,
        pageNum: 1, // 当前显示第几页
        pageSize: 10 // 每一页显示条数
      },
      formInline: {
        auditStatus: 'APPLY',
        agentId: null,
        agentName: null,
        dateEnd: null,
        dateStart: null,
        orderNo: null,
        orderStatus: null,
        paymentStatus: null,
        paymentType: null,
        phone: null,
        salesmanId: null,
        refundType: null,
        storeCode: null,
        storeId: null,
        storeName: null,
        storeType: null,
        userId: null,
        userName: null
      },
      tableData: [],
      basicsInfo: {
        storeId: '',
        storeCode: '',
        storeName: '',
        fullName: '',
        storeTypeList: []
      },
      value2: [
        this.$moment().subtract(6, 'months').format('YYYY-MM-DD'),
        this.$moment().format('YYYY-MM-DD')
      ],
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now() - 8.64e6
        },
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      tradeMethods: [{
        id: 'EXPRESS_FEE',
        // id: 'TRADE_ORDER_FEE',
        name: '订单扣费'
      }, {
        id: 'REBATE',
        // id: 'REBATE',
        name: '订单返款'
      }]
    }
  },
  created () {
    if (sessionStorage.getItem('searchFlag') === 'true') {
      this.formInline = JSON.parse(sessionStorage.getItem('queryParams'))
      this.queryInfo = JSON.parse(sessionStorage.getItem('queryInfo'))
      this.storeListByCode = JSON.parse(sessionStorage.getItem('storeListByCode'))
      this.userList = JSON.parse(sessionStorage.getItem('userList'))

      sessionStorage.removeItem('searchFlag')
    } else {
      // 首次进入列表页,清除缓存中的搜索条件
      sessionStorage.removeItem('queryParams')
      sessionStorage.removeItem('queryInfo')
      sessionStorage.removeItem('storeListByCode')
      sessionStorage.removeItem('userList')
    }
    if (this.$route.query.paymentStatus === 'UNPAID') {
      this.formInline.paymentStatus = 'UNPAID'
    }
    this.onSubmit(this.queryInfo)
    // this.getBasicsInfo()
  },
  destroyed () {
    // 销毁
    console.log('页面销毁')
    sessionStorage.removeItem('searchFlag')
  },
  methods: {
    goInfo (row) {
      sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
      sessionStorage.setItem('queryParams', JSON.stringify(this.formInline))
      sessionStorage.setItem('storeListByCode', JSON.stringify(this.storeListByCode))
      sessionStorage.setItem('userList', JSON.stringify(this.userList))
      this.$router.push({ path: '/refund/express-fee', query: { userId: row.order.userId, orderNo: row.order.orderNo, refundId: row.id, storeCode: row.order.storeCode, storeName: row.order.storeName } })
    },
    getBasicsInfo () {
      storeTypeGetStoreTypeList().then(res => {
        this.basicsInfo.storeTypeList = res.data.data
      })
    },
    onSubmit () {
      if (sessionStorage.getItem('searchFlag')) {
        sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
        sessionStorage.setItem('queryParams', JSON.stringify(this.formInline))
        sessionStorage.setItem('storeListByCode', JSON.stringify(this.storeListByCode))
        sessionStorage.setItem('userList', JSON.stringify(this.userList))
      }
      getOrderRefunds({
        page: this.queryInfo.pageNum - 1,
        size: this.queryInfo.pageSize,
        vo: Object.fromEntries(Object.entries(this.formInline).map(([key, value]) => [key, value === '' ? null : value]))
      }
      ).then((res) => {
        this.queryInfo.total = res.data.data.total
        this.tableData = res.data.data.content
      })
    },
    rowClassName ({
      row,
      rowIndex
    }) {
      row.index = rowIndex
    },
    exportExcel () {
      const loading = this.$loading({
        lock: true,
        text: '正在导出表格，请稍后',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      refundExport(Object.fromEntries(Object.entries(this.formInline).map(([key, value]) => [key, value === '' ? null : value]))).then(res => {
        let blob = res.data
        const fileReader = new FileReader()
        fileReader.readAsDataURL(blob)
        fileReader.onload = (event) => {
          let a = document.createElement('a')
          let _fileName = '售后表' + this.value2[0] + '-' + this.value2[1] + '.xls'
          a.download = _fileName
          a.href = event.target.result
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
          loading.close()
        }
      })
    },
    handleSelect (item) {
      this.formInline.storeId = item.id
      this.basicsInfo.storeName = item.companyName
    },
    selectUserList (val) {
      if (val.trim()) {
        getAllUsersByUserName(val).then(res => {
          if (res.data.success) {
            this.userList = res.data.data
          }
        })
      }
    },
    selectSalemanList (val) {
      if (val.trim()) {
        getSalesmanByFullName(val).then(res => {
          if (res.data.success) {
            this.salemanList = res.data.data
          }
        })
      }
    },
    filterMethod (val) {
      if (val.trim()) {
        storeQueryListByCode(val).then(res => {
          if (res.data.success) {
            this.storeListByCode = res.data.data
          }
        })
      }
    },
    filterByName (val) {
      if (val.trim()) {
        storeQueryListByName(val).then(res => {
          if (res.data.success) {
            this.storeListByCode = res.data.data
          }
        })
      }
    },
    SelectStoreName (item) {
      this.formInline.storeId = item.id
      this.basicsInfo.storeCode = item.code
    },
    queryStoreNameAsync (queryString, cb) {
      storeQueryListByName(queryString).then(res => {
        res.data.data.forEach(item => {
          item.value = item.code
        })
        cb(res.data.data)
      })
    },
    selectFullName (item) {
      this.formInline.salesmanId = item.id
    },
    queryFullNameAsync (queryString, cb) {
      // 改成业务的模糊查询
      getSalesmanByFullName(queryString).then(res => {
        res.data.data.forEach(item => {
          item.value = item.fullName
        })
        cb(res.data.data)
      })
    },
    changePage (val) {
      this.queryInfo = val
      this.onSubmit()
    }
  }
}
</script>
<style lang="less" scoped>
@deep: ~">>>";

@{deep} .data-list .el-table tr td {
  height: 40px !important;
  padding: 0 !important;
}
</style>
